/**
 * Clerk wiring. AFELL keeps Clerk as its auth provider (docs/port-plan.md):
 * the SPA holds a Clerk session and every API call carries its JWT as a
 * Bearer token, which the backend's ClerkAuthentication resolves to a
 * MinimaUser. With no publishable key configured the app still boots —
 * auth-gated routes just show a not-configured notice.
 */
export const CLERK_PUBLISHABLE_KEY: string | undefined = import.meta.env
  .VITE_CLERK_PUBLISHABLE_KEY;

export const clerkEnabled = Boolean(CLERK_PUBLISHABLE_KEY);

/** Session JWT for API calls; null when signed out or Clerk is not loaded. */
export async function getClerkToken(): Promise<string | null> {
  const clerk = (window as { Clerk?: { session?: { getToken(): Promise<string | null> } } })
    .Clerk;
  try {
    return (await clerk?.session?.getToken()) ?? null;
  } catch {
    return null;
  }
}
